// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legend {
    font-family: Arial, sans-serif;
    font-size: 14px;
    padding: 10px;
    z-index: 50 !important;
}

.legend h4 {
    margin-bottom: 0.5rem;
}

.legend-gradient-bar {
    height: 15px;
    background: linear-gradient(to right, hsl(0, 80%, 50%), hsl(60, 80%, 50%), hsl(120, 80%, 50%));
    border: 1px solid #ccc;
    margin-bottom: 5px;
}

.legend-scale {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    margin-bottom: 4px;
}

.legend-unit {
    font-size: 12px;
    text-align: center;
    color: #555;
}

.legend-bar {
    width: 200px;
    height: 15px;
    border: 1px solid #ccc;
    margin-bottom: 5px;
  }
  
  .legend-labels {
    display: flex;
    justify-content: space-between;
    font-size: 0.8rem;
  }
  
`, "",{"version":3,"sources":["webpack://./src/legend.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,8FAA8F;IAC9F,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;EACnB","sourcesContent":[".legend {\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n    padding: 10px;\n    z-index: 50 !important;\n}\n\n.legend h4 {\n    margin-bottom: 0.5rem;\n}\n\n.legend-gradient-bar {\n    height: 15px;\n    background: linear-gradient(to right, hsl(0, 80%, 50%), hsl(60, 80%, 50%), hsl(120, 80%, 50%));\n    border: 1px solid #ccc;\n    margin-bottom: 5px;\n}\n\n.legend-scale {\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    margin-bottom: 4px;\n}\n\n.legend-unit {\n    font-size: 12px;\n    text-align: center;\n    color: #555;\n}\n\n.legend-bar {\n    width: 200px;\n    height: 15px;\n    border: 1px solid #ccc;\n    margin-bottom: 5px;\n  }\n  \n  .legend-labels {\n    display: flex;\n    justify-content: space-between;\n    font-size: 0.8rem;\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
